import { requireAuth } from '@/features/auth/guards/require-auth'
import { ProductionReportsListPage } from '@/features/production-reports/pages/production-reports-list-page'
import { productionReportsGlobalListQuery } from '@/features/production-reports/queries/production-report-queries'
import { projectsListQuery } from '@/features/projects/queries/projects-query'
import { usersListQuery } from '@/features/references/users/users-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/production-reports/')({
  beforeLoad: requireAuth,
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(productionReportsGlobalListQuery()),
      queryClient.ensureQueryData(projectsListQuery()),
      queryClient.ensureQueryData(usersListQuery()),
    ]),
  component: ProductionReportsListPage,
  staticData: { crumb: messages.crumbs.productionReports },
})
